<div [formGroup]="parentForm">
    <mat-form-field class="example-full-width w-100 sen-input-tag">
        <input matInput formControlName="full" [readonly]="true">
        <mat-icon matSuffix class="sen-cursor-pointer sen-active-color" (click)="openGMapAddress()">location_on
        </mat-icon>
    </mat-form-field>
</div>